import { useTranslation } from 'react-i18next';
import { ParkAvailability } from 'apollo/types';
import { tosLink } from 'assets/media/policies';
import { Content } from './Collapse/types';

const formatHour = (time: string): string => {
  const [hours, minutes] = time.split(':');
  return `${hours}:${minutes} `;
};

const useFaqContent = (parkAvailability: ParkAvailability[]): Content[] => {
  const { t } = useTranslation();

  const winter = parkAvailability.find((a) => a.isWinterTime === true);
  const summer = parkAvailability.find((a) => a.isWinterTime === false);

  if (winter === undefined || summer === undefined) {
    return [];
  }

  return t('pages.faq.content', {
    returnObjects: true,
    winterAperture: formatHour(winter.aperture),
    winterClosure: formatHour(winter.closure),
    summerAperture: formatHour(summer.aperture),
    summerClosure: formatHour(summer.closure),
    tosLink,
  }) as unknown as Content[];
};

export default useFaqContent;
